import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../lib/domain';
import { BasicHeader } from '../../components/basic_header';
import ErrorWrapper from '../../lib/error_wrapper';
import FilterFixedInput from '../../components/filter_fixed_input';
import { Select, DatePicker, Table, Divider, Button, message, Spin, Tooltip, Space } from 'antd';
import NetworkSelect from '../../lib/ui/network_select';
import moment from 'moment';
import { CustomStats } from '../../components/custom_stat';
import { GetAppOutlined, DnsOutlined, MenuOpenOutlined } from '@material-ui/icons'
import { COLORS } from '../theme';
import { PopUpForm } from '../../lib/ui/popupform';
import { showErrorInNotification, defaultDateFormat, copyStringToClipboard, formatMoney } from '../../lib/util';
import { Link } from 'react-router-dom';
import { activity_quick_menu } from '../../util/ui_util';
import { TransparentButton, TextTag } from '../../components/basic_items';
import CustomDateRangePicker from '../../components/custom_date_range';
import DayDifferennceTag from '../../components/day_difference_tag';


const queryString = require('query-string');

class FetcherLogs extends Component {
  constructor(props) {
    super(props)

    this.repository_id = props.match.params.repository_id;

    this.state = {
      filter_query: {

      },
      selected_data: {

      },
      re_run_modal: false,
      form_data: {},
      loading: true,
      repository_obj: {}
    }

    this.detail_repository = RESTExecutor.detail().forId(this.repository_id).config({
      label: 'repository_detail'
    }).callbacks((success) => {
      this.setState({
        loading: false, repository_obj: success.result
      });
      this.list_fetcher_logs.config({
        params: {
          ...this.state.filter_query
        }
      }).execute();

    }, (error) => {
      this.setState({
        loading: false
      })
    }).connect(props.domains.fetcher);
    this.list_fetcher_logs = RESTExecutor.list().config({
      label: 'fetcher_logs',
      params: {}
    }).connect(props.domains.fetcher);


    this.download_response = RESTExecutor.detail().config({
      label: 'download_responses'
    }).callbacks((success) => {
      window.open(success.result.url, '_blank');
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.fetcher);

    this.re_run = RESTExecutor.post().config({
      label: 'rerun_responses'
    }).callbacks((success) => {
      message.success(success.result.message || "Running selector.");
      this.setState({
        selected_data: {},
        re_run_modal: false,
        form_data: {}
      })
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.fetcher);

  }

  reRun = (data) => {

    this.re_run.forId(this.state.selected_data.id).execute(data);
    // Rerun for given responses
  }

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }
  render() {

    let re_run_resp = this.re_run.response();
    let list_fetcher_logs_resp = this.list_fetcher_logs.response();
    let detail_repository_resp = this.detail_repository.response();

    let list_fetcher_logs_data = list_fetcher_logs_resp.result || {};
    let rowsData = list_fetcher_logs_data.rows || [];
    let rowsMeta = list_fetcher_logs_resp.meta || {}

    const { filter_query, selected_data, loading, repository_obj } = this.state;
    if (loading) {
      return <center><Spin /></center>
    }
    const required_fields = [
      { filterable: true, index: 'selectors', name: "Selector", help_text: "Which selector to run for given file.", type: 'networkselect', url: `/fetcher-responses/${selected_data.id}/selectors`, mode: 'tags' }
    ]
    return (<ErrorWrapper error={detail_repository_resp}
      onReload={() => {
        this.setState({ loading: true })
        this.detail_repository.execute()
      }}>
      <BasicHeader
        title={repository_obj.name}
        titleType="Repository"
        subtitle="Logs"
        right={[
          <Link to={`/activity/fetcher/${this.repository_id}/responses`} >
            <TransparentButton
              label="Responses"
              icon={<DnsOutlined />}
              hint="View Responses"
            />
          </Link>
        ]}
      />

      <PopUpForm
        width="60%"
        key={`${selected_data.id}rerun`}
        title={"Selector to Rerun"}
        show_title_only
        forCreate={true}
        initialData={this.state.form_data}
        fields={required_fields}
        open={this.state.re_run_modal}
        networkState={re_run_resp}
        onClose={() => {
          console.log("closing upload form")
          this.setState({
            re_run_modal: false,
            selected_data: {},
            form_data: {}
          })
        }
        }
        onSubmit={(data) => {
          console.log("DATA", data);
          this.reRun(data);
        }}
      />
      <div className='filter-card'>
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          // justifyContent: 'space-between',
          flexWrap: 'wrap',
          paddingTop: 4, paddingBottom: 4
        }}>

          <FilterFixedInput label="Mode">
            <Select
              allowClear
              showSearch
              className={filter_query.mode ? 'filter-option-selected' : ''}
              style={{
              }}
              placeholder="Mode"
              value={filter_query.mode}
              // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              onChange={(value, e) => {
                this.stateUpdater({
                  stateKey: 'filter_query',
                  valueKey: 'mode',
                  value: value,
                  callback: () => {
                    this.props.history.push({
                      // pathname:"users",
                      search: queryString.stringify({ ...this.state.filter_query, page: 1 })
                    })
                  }
                });
              }}
            >
              <Select.Option value={"AUTOMATED"} key={"AUTOMATED"}>
                AUTOMATED
                  </Select.Option>
              <Select.Option value={"MANUAL"} key={"MANUAL"}>
                MANUAL
                  </Select.Option>
            </Select>
          </FilterFixedInput>
          <FilterFixedInput label="Response">
            <Select
              allowClear
              showSearch
              className={filter_query.has_response != null ? 'filter-option-selected' : ''}
              style={{
              }}
              placeholder="Empty/Non Empty"
              value={filter_query.has_response}
              // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              onChange={(value, e) => {
                this.stateUpdater({
                  stateKey: 'filter_query',
                  valueKey: 'has_response',
                  value: value,
                  callback: () => {
                    this.props.history.push({
                      // pathname:"users",
                      search: queryString.stringify({ ...this.state.filter_query, page: 1 })
                    })
                  }
                });
              }}
            >
              <Select.Option value={'false'}>
                Empty
                  </Select.Option>
              <Select.Option value={'true'}>
                Non-empty
                  </Select.Option>
            </Select>
          </FilterFixedInput>
          <FilterFixedInput label="Execution Date">
            <CustomDateRangePicker
              style={{
                // width: 400,
                // marginLeft: 16,
                flex: null
              }}
              startDate={filter_query.dateFrom ? moment(filter_query.dateFrom, defaultDateFormat) : null}
              endDate={filter_query.dateTo ? moment(filter_query.dateTo, defaultDateFormat) : null}
              onChange={(dates) => {
                //   console.log("GOT DATES",dates.startDate.toISOString(),dates.endDate.toISOString())
                this.stateUpdater({
                  stateKey: 'filter_query', appendObj: {
                    dateFrom: dates.startDate.format(defaultDateFormat),
                    dateTo: dates.endDate.format(defaultDateFormat), page: 1
                  },
                  callback: () => {
                    this.props.history.push({
                      search: queryString.stringify(this.state.filter_query)
                    })
                  }
                })
              }}

            />
            {/* <DatePicker
                placeholder="Select Date"
                value={filter_query.executed_at ? moment(filter_query.executed_at, "YYYY-MM-DD") : null}
                format="YYYY-MM-DD"
                onChange={(date, dateString) => {
                  this.stateUpdater({
                    stateKey: 'filter_query', valueKey: 'executed_at', value: date ? dateString : null, callback: () => {
                      this.props.history.push({
                        search: queryString.stringify({ ...this.state.filter_query, page: 1 })
                      })
                    }
                  });
                }
                }
                style={{ }} /> */}
          </FilterFixedInput>
        </div>
      </div>

      <ErrorWrapper
        error={list_fetcher_logs_resp}
        onReload={() => {
          this.list_fetcher_logs.execute()
        }}>
        <div
        >
          <Table
            loading={list_fetcher_logs_resp.fetching}
            dataSource={rowsData}
            showHeader={false}
            // rowKey={(record) => `${record.id}`}
            className='noHover no-separator-table single-column no-padding-table'
            columns={[
              {
                dataIndex: '',
                render: (data) => {
                  return <FetcherLogItem

                    data={data}
                    onRerun={(data) => {
                      console.log("running for ", data);
                      this.setState({
                        selected_data: data,
                        re_run_modal: true
                      })
                    }}
                    onDownload={(data) => {

                      this.download_response.forId(data.id).execute()
                    }}
                  />
                }

              }
            ]}
            pagination={{
              simple: false,
              size: 'small',
              position: 'bottom',
              onChange: (current, size) => {
                this.props.history.push({
                  search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                })
              },
              defaultCurrent: 1,
              current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
              pageSize: (rowsMeta && rowsMeta.requested_count),
              total: (rowsMeta && rowsMeta.total_count > 10000 ? 10000 : rowsMeta.total_count),
              showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${rowsMeta.total_count > 10000 ? `10,000+` : formatMoney(rowsMeta.total_count,0)} items`
            }}
          />
        </div>
      </ErrorWrapper>
    </ErrorWrapper>
    );
  }

  componentDidMount() {

    let new_filter_query = {};
    if (this.props.location && this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      new_filter_query = parsed;
    }
    this.setState({
      filter_query: {
        per_page: 50,
        page: 1,
        ...new_filter_query,
        repository_id: this.repository_id
      }
    }, () => {
      this.detail_repository.execute()
    })

    // this.list_fetcher_logs.execute()
  }


  componentWillReceiveProps(nextProps) {
    var oldrepository_id = this.props.match.params.repository_id;
    var newrepository_id = nextProps.match.params.repository_id;


    if (oldrepository_id !== newrepository_id || (
      this.props.location && (this.props.location.search !== nextProps.location.search)
    )) {
      this.repository_id = newrepository_id;
      const parsed = queryString.parse(nextProps.location.search);
      this.setState({
        filter_query: {
          per_page: 50,
          page: 1,
          ...parsed,
          repository_id: this.repository_id
        },
      }, () => {
        if (oldrepository_id !== newrepository_id) {
          this.setState({
            loading: true
          }, () => {
            this.detail_repository.forId(this.repository_id).execute()
          })
        } else {
          this.list_fetcher_logs.config({
            params: {
              ...this.state.filter_query
            }
          }).execute()
        }
      })

    }
  }
}

export default withDomains(FetcherLogs, "fetcher");




const FetcherLogItem = (props) => {
  let data = props.data || {};
  let responses = data.responses || [];
  let total_responses_count = data.response_count;

  return <div key={data.key} className='default-card' style={{
    margin: 8,
    marginTop: 4, marginBottom: 4
  }}>

    <div style={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingTop: 16,
      paddingLeft: 20, paddingRight: 20,
      paddingBottom: 16,
      alignItems: 'center'
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
      }}>
        <Space size={20}>
          <div className='credit-circle'>{data.manual == true ? "M" : "A"}</div>
          {data.message != null ?
            <Tooltip title={<div className='log-text'>
              {(data.message || "")}
            </div>}
              placement='bottomRight'
              arrowPointAtCenter
              autoAdjustOverflow
              overlayClassName={data.message ? 'error-tooltip side-scroll' : ''}
            >
              <div onClick={() => {
                copyStringToClipboard(data.message);
                message.success("Copied")
              }} className={`dot-indicator danger`}></div>
            </Tooltip> : null
            // <div className={`dot-indicator`}></div>
          }
          <div className='description-text' style={{
            fontWeight: 'bold'
          }} >{data.executed_at}</div>
          <DayDifferennceTag date={data.executed_at} />

        </Space>
      </div>
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
      }}>
        <Space size={20}>
          <div className='description-text' style={{
            fontWeight: 'bold'
          }}>{data.response_count} Responses</div>
          <TextTag type={data.status == "Completed" ? "success" :
            data.status == "Failed" ? 'danger' : 'warning'

          } label={(data.status || "").toUpperCase()} />
        </Space>

      </div>


      {/* <CustomStats
          label={data.message != null ?<div style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center'
          }}> 
          <span>STATUS</span>
          <Tooltip title={<div className='log-text'>
            {(data.message || "")}
          </div>}
            placement='bottomRight'
            arrowPointAtCenter
            autoAdjustOverflow
            overlayClassName={data.message ? 'error-tooltip side-scroll' : ''}
          >
            <div
              onClick={(e) => {
                copyStringToClipboard(data.message);
                message.success("Copied")
              }}
              className='hand-cursor' style={{
                height: 10, minHeight: 10,
                width: 10, minWidth: 10,
                marginLeft:8,
                borderRadius: 5,
                backgroundColor: data.message ? COLORS.danger_primary : COLORS.success_primary,
              }}>
            </div></Tooltip> </div> : "STATUS"}
          title={(data.status || "").toUpperCase()}
          titleStyle={{
            fontWeight: 'normal',
            color: data.status == "Completed" ? COLORS.success_primary : data.status == "Failed" ? COLORS.danger_primary : null
          }} /> */}

    </div>
    {responses.length != 0 && <Divider style={{ marginTop: 0, marginBottom: 0 }} />}

    {responses.length == 0 ?
      <div style={{
        paddingLeft: 0,
        paddingBottom: 0
      }}>
        {/* <span className='stat-subtitle'>No any responses</span> */}
      </div>
      :
      <Table
        dataSource={responses}
        className='small-table  separator-table '
        size='small'
        // rowClassName={(record) => {
        // console.log("record",record);
        //   return record.error == true ? 'error-row' : ''
        // }}
        pagination={false}
        columns={[
          {
            title: "RESPONSES",
            dataIndex: 'file_path',
            key: 'file_path',
            className: 'word-break',
            render: (value, record) => {
              return <Link style={{
                display: 'flex',
                alignItems: 'center'
              }} to={`/activity/fetcher/responses/${record.fetcher_log_id}/${record.id}`}>
                {record.error_message ?
                  <Tooltip title={<div className='log-text'>
                    {(record.error_message || "")}
                  </div>}
                    placement='bottomRight'
                    arrowPointAtCenter
                    autoAdjustOverflow
                    overlayClassName={record.error_message ? 'error-tooltip side-scroll' : ''}
                  >
                    <div onClick={() => {
                      copyStringToClipboard(record.error_message);
                      message.success("Copied")
                    }} className={`dot-indicator ${record.error == true ? 'danger' : ''}`} style={{
                      marginRight: 8
                    }}></div>
                  </Tooltip> :
                  <div className={`dot-indicator ${record.error == true ? 'danger' : ''}`} style={{
                    marginRight: 8
                  }}></div>
                }
                <span>
                  {value}</span>
              </Link>
            }
          },
          {
            title: "RESPONSE SIZE",
            dataIndex: 'file_size',
            key: 'file_size',
            width: 120,
            render: (response_size = 0) => {
              return (response_size / 1024).toLocaleString() + " Kb"
            }
          },
          {
            title: "ACTIONS",
            width: 200,
            className: 'center-align',
            render: (record) => {
              return <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <Button title="Rerun"
                  onClick={() => {
                    typeof props.onRerun === 'function' && props.onRerun(record)
                  }}
                  style={{
                    padding: 0
                  }} type='link'>Re-run</Button>
                <Divider type='vertical' />
                <GetAppOutlined
                  onClick={() => {
                    typeof props.onDownload === 'function' && props.onDownload(record)
                  }}
                  titleAccess="Download File" className='basic-icon hand-cursor' />

              </div>
            }
          }
        ]}
      />}
    {total_responses_count > responses.length && <React.Fragment>
      <Divider style={{
        marginTop: 0, marginBottom: 12
      }} />
      <div style={{
        paddingBottom: 8
      }}>
        <Link to={`/activity/fetcher/logs/${data.id}`}>
          <Button type='link' icon={<MenuOpenOutlined style={{
            transform: 'rotateZ(180deg)',
            marginRight: 8
          }} />} style={{
            display: 'flex',
            alignItems: 'center'
          }}>VIEW ALL RESPONSES </Button>
        </Link>
      </div>
    </React.Fragment>}

  </div>
}